import { axios } from '../../../services/axios';
import * as CONST from '../../constants';

const onSuccess = (dispatch, data) => {
  dispatch({ type: CONST.STATUS_DELETE_SUCCESS, data });
};

const onFailed = (dispatch, error) => {
  dispatch({ type: CONST.STATUS_DELETE_ERROR, error });
};

const handleResponse = (dispatch, response) => {
  if (response.status === 200) {
    onSuccess(dispatch, response.data);
  } else {
    onFailed(dispatch, response.data);
  }
};

export const statusDelete = (statusId) => {
  return async (dispatch) => {
    dispatch({ type: CONST.STATUS_DELETE_REQUEST });

    axios.delete(`/statuses/${statusId}`).then((response) => {
      handleResponse(dispatch, response);
    });
  };
};
